import { useTranslation } from "react-i18next";
import smallLogo from "../../../../assets/images/logo-small.svg";

const FormHeader = () => {
    const { t } = useTranslation("common");

    return (
        <div className="section-login__title">
            <img src={smallLogo} alt="Small logo" />
            <h1>
                {t("welcome")}{" "}
                <span>
                    Equilibrio <sub>{t("KIDS APP")}</sub>
                </span>
            </h1>
        </div>
    );
};

export default FormHeader;
